export default [{
  path: "/reports",
  name: "Reports",
  component: () => import("@/pages/reports/Index.vue")
}, {
  path: "/reports/cashier",
  name: "CashierReport",
  component: () => import("@/pages/reports/CashierV2.vue")
}, {
  path: "/reports/sales-by-articles",
  name: "SalesByArticlesReport",
  component: () => import("@/pages/reports/SalesByArticles.vue")
},
{
  // PMS-427: the same page as Sales by Article; the route NAME switches it (see creditMemoVoidReport.ts).
  path: "/reports/credit-memo-void",
  name: "CreditMemoVoidReport",
  component: () => import("@/pages/reports/SalesByArticles.vue")
},
{
  path: "/reports/z-report",
  name: "ZReport",
  component: () => import("@/pages/reports/ZReport.vue")
},
{
  path: "/reports/z-sales-summary-report",
  name: "ZSalesSummaryReport",
  component: () => import("@/pages/reports/ZSalesSummaryReport.vue")
},
{
  path: "/reports/x-report",
  name: "XReport",
  component: () => import("@/pages/reports/XReport.vue"),
},
{
  path: "/reports/bir-e-journal",
  name: "BIREJournal",
  component: () => import("@/pages/reports/BIREJournal.vue"),
},
{
  path: "/reports/pos-adjustment-log",
  name: "POSAdjustmentLog",
  component: () => import("@/pages/reports/POSAdjustmentLog.vue"),
},
{
  path: "/reports/bir-sc-discount-report",
  name: "BIRSCDiscountReport",
  component: () => import("@/pages/reports/BIRSCDiscountReport.vue"),
},
{
  path: "/reports/bir-pwd-discount-report",
  name: "BIRPWDDiscountReport",
  component: () => import("@/pages/reports/BIRPWDDiscountReport.vue"),
},
{
  path: "/reports/top-sales-by-articles",
  name: "TopSalesByArticle",
  component: () => import("@/pages/reports/TopSalesByArticle.vue")
},
{
  path: "/reports/bottom-sales-by-articles",
  name: "BottomSalesByArticle",
  component: () => import("@/pages/reports/TopSalesByArticle.vue")
},
{
  path: "/reports/discounts",
  name: "DiscountsReport",
  component: () => import("@/pages/reports/Discounts.vue")
}, {
  path: "/reports/reservation-comments",
  name: "ReservationCommentReport",
  component: () => import("@/pages/reports/ReservationComments.vue")
}, {
  path: "/reports/order-detail-by-payment",
  name: "OrderDetailByPaymentReport",
  component: () => import("@/pages/reports/OrderDetailByPayment.vue")
},
{
  path: "/reports/reservation-comments",
  name: "ReservationCommentReport",
  component: () => import("@/pages/reports/ReservationComments.vue")
},
{
  path: "/reports/complimentary-report-with-cost",
  name: "ComplimentaryReportWithCost",
  component: () => import("@/pages/reports/ComplimentaryReportWithCost.vue")
},
{
  path: "/reports/revenue-center",
  name: "RevenueCenter",
  component: () => import("@/pages/reports/RevenueCenter.vue")
},
{
  path: "/reports/production-by-waiter",
  name: "ProductionByWaiter",
  component: () => import("@/pages/reports/ProductionByWaiter.vue")
},
{
  path: "/reports/sales-by-hour",
  name: "SalesByHour",
  component: () => import("@/pages/reports/SalesByHour.vue")
},
{
  path: "/reports/sales-by-category",
  name: "SalesByCategory",
  component: () => import("@/pages/reports/SalesByCategory.vue")
},
{
  path: "/reports/inventory-and-stock",
  name: "InventoryAndStock",
  component: () => import("@/pages/reports/InventoryAndStock.vue")
},
{
  path: "/reports/screen-orders",
  name: "ScreenOrders",
  component: () => import("@/pages/screens/ScreenOrdersReport.vue")
}, {
  path: "/captain-order",
  name: "CaptainOrder",
  component: () => import("@/pages/screens/CaptainOrder.vue")
}, {
  path: "/reports/sales-by-table-labels",
  name: "SalesByTableLabelsReport",
  component: () => import("@/pages/reports/SalesByTableLabels.vue")
},
{
  path: "/reports/sales-summary-by-package",
  name: "SalesSummaryByPackageReport",
  component: () => import("@/pages/reports/SalesSummaryByPackage.vue")
},
];
